import { useEffect, useState } from "react";
import CustomButton from "../../../../../components/CustomButton";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import SvgIcon from "../../../../../helpers/SvgIcon";
import { postLoadPackageInCar } from "../../../../../redux/api/expedition.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import {
  CargoNodeDataInterface,
  TransportsDataInterface,
} from "../../../../../redux/interfaces/raports.interface";
import ModalWrapper from "../../../../../components/Modal/ModalWrapper";
import Text from "../../../../../styleguide/Text";
import { fetchCargoNode } from "../../../../../redux/api/raports.api";

function CargoNodeActionButtons({
  crudData,
}: {
  itemId: string;
  crudData: CargoNodeDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();

  const { id_doctrans_detl, id_doctrans } = crudData;

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedCar, setSelectedCar] =
    useState<TransportsDataInterface | null>(null);

  useEffect(() => {
    if (isModalOpen) {
      if (crudData.transporturi?.length === 1) {
        setSelectedCar(crudData.transporturi[0]);
      } else {
        setSelectedCar(null);
      }
    }
  }, [isModalOpen, crudData.transporturi]);

  const handleShowModal = () => {
    setIsModalOpen(true);
  };

  const wrongDestination =
    !crudData.sn_bin && crudData.id_nod !== crudData.id_nod_destinatie_colet;

  const onClose = () => {
    setIsModalOpen(false);
    setSelectedCar(null);
  };

  const isSubmitDisabled =
    !id_doctrans || !id_doctrans_detl || !selectedCar?.id_transport;

  const handleOnSubmit = async () => {
    if (!selectedCar?.id_transport) return;

    setIsLoading(true);

    const resultAction = await dispatch(
      postLoadPackageInCar({
        id_doctrans_detl,
        id_transport: selectedCar.id_transport,
        id_doctrans,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postLoadPackageInCar) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postLoadPackageInCar) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        fetchCargoNode({
          page: 1,
          perPage: 999,
          idNod: crudData.id_nod,
        }),
      );

      onClose();
    }
  };

  return (
    <>
      {crudData.doc_trans &&
        crudData.transporturi.length > 0 &&
        !wrongDestination && (
          <div>
            <CustomButton
              variant="contained"
              className="mt-1 me-1"
              tooltipTitle="Incarca coletul in masina"
              onClick={handleShowModal}>
              <SvgIcon type="UPLOAD_CARGO" fill="white" />
            </CustomButton>

            <ModalWrapper
              show={!!isModalOpen}
              title={"Incarca coletul in masina"}
              modalSize="sm"
              handleClose={onClose}>
              <div className="d-flex flex-column">
                <h5>Alege masina pentru a incarca coletul:</h5>

                {crudData.transporturi.map((item, idx) => {
                  return (
                    <div className="d-flex flex-row" key={idx}>
                      <p
                        style={{ maxWidth: 100 }}
                        className={`${
                          selectedCar?.id_transport === item.id_transport
                            ? "border border-primary border-2"
                            : "border border-2"
                        } badge px-3 py-2 mx-2 text-info bg-info bg-opacity-10 cursor-pointer`}
                        onClick={() => setSelectedCar(item)}>
                        {item.masina}
                      </p>
                    </div>
                  );
                })}
              </div>

              <CustomButton
                type="submit"
                variant="contained"
                fullWidth
                className="btn btn-lg btn-primary w-100 mt-5"
                disabled={isSubmitDisabled}
                loading={isLoading}
                onClick={handleOnSubmit}>
                <Text variant="body1" className="indicator-label" isBold>
                  Salveaza
                </Text>
              </CustomButton>
            </ModalWrapper>
          </div>
        )}
    </>
  );
}

export default CargoNodeActionButtons;
